module.exports = __webpack_public_path__ + "img/arm.06509258.svg";